export function formatIssuingCarrierOptionLabel(
  name?: string | null,
  airline?: string | null,
): string {
  const carrierName = (name ?? "").trim();
  const iata = (airline ?? "").trim().toUpperCase();
  if (iata && carrierName) return `${iata} - ${carrierName}`;
  return carrierName || iata;
}
